module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.params.type) + " Docs")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [(_vm.$route.params.type == 'Export') ? _c('b-card-text', [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("BOOKING ORDER")]), _vm._v(" "), (_vm.ffBookingOrder.length > 0) ? _c('div', _vm._l((_vm.ffBookingOrder), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item.uploadBooking != '' && item.uploadBooking != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item.uploadBooking,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("SHIPPER INVOICE")]), _vm._v(" "), (_vm.SBPageDocs.length > 0) ? _c('div', _vm._l((_vm.SBPageDocs), function(item1, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item1.invoiceUpload != '' && item1.invoiceUpload != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item1.invoiceUpload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("CARGO LIST")]), _vm._v(" "), (_vm.SBPageDocs.length > 0) ? _c('div', _vm._l((_vm.SBPageDocs), function(item10, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item10.cargoUpload != '' && item10.cargoUpload != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item10.cargoUpload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("LET EXPORT COPY")]), _vm._v(" "), (_vm.LETEXPORTMAILDOC.length > 0) ? _c('div', _vm._l((_vm.LETEXPORTMAILDOC), function(item101, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item101.upload_doc_mail != '' && item101.upload_doc_mail != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_EX_LET_MAILDOC_CLOUDMAILING_UPLOADS/" + item101.upload_doc_mail,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("SHIPPING BILL")]), _vm._v(" "), (_vm.SBPageDocs.length > 0) ? _c('div', _vm._l((_vm.SBPageDocs), function(item3, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item3.shippingBillUpload != '' && item3.shippingBillUpload != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Export_Uploads/" + item3.shippingBillUpload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])])])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type == 'AirExport') ? _c('b-card-text', [(_vm.airExportExecPageDoc.length > 0) ? _c('div', {
    staticClass: "row mt-3"
  }, _vm._l((_vm.airExportExecPageDoc), function(item4, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-2"
    }, [_c('label', {
      staticStyle: {
        "text-transform": "uppercase !important"
      }
    }, [_vm._v(_vm._s(item4.documentType))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('a', {
      staticStyle: {
        "margin-left": "-15px"
      },
      attrs: {
        "href": _vm.docURL + "/FF_Air_Export_Uploads/" + item4.uploadDocumentType,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document")])])])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.params.type == 'Import') ? _c('b-card-text', [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Shipment Arrival Notice")]), _vm._v(" "), (_vm.SeaImportEntryPageDoc.length > 0) ? _c('div', _vm._l((_vm.SeaImportEntryPageDoc), function(item5, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item5.shippingArrivalNoticmailSentDate != null) ? _c('a', {
      staticClass: "showMoreData",
      attrs: {
        "target": "_blank",
        "download": ""
      },
      on: {
        "click": function($event) {
          _vm.SendShipmentArrival(item5.ffImportId)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1)), _c('br'), _vm._v("\n                      Sent on " + _vm._s(item5.shippingArrivalNoticmailSentDate) + "\n                      ")]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Shipment Arrival Notice Not Sent")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Shipment Arrival Notice Not Sent")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("BL 1")]), _vm._v(" "), (_vm.SeaImportEntryPageDoc.length > 0) ? _c('div', _vm._l((_vm.SeaImportEntryPageDoc), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item.firstBLupload != '' && item.firstBLupload != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item.firstBLupload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("HOUSE BL")]), _vm._v(" "), (_vm.SecBLSeaImportEntryPageDoc.length > 0) ? _c('div', _vm._l((_vm.SecBLSeaImportEntryPageDoc), function(item1, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item1.secondBLupload != '' && item1.secondBLupload != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item1.secondBLupload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("DO")]), _vm._v(" "), (_vm.execSeaImportEntryPageDoc.length > 0) ? _c('div', _vm._l((_vm.execSeaImportEntryPageDoc), function(item10, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item10.uploadDO != '' && item10.uploadDO != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item10.uploadDO,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("OTHER DOCUMENTS")]), _vm._v(" "), (_vm.execSeaImportEntryPageDoc.length > 0 && _vm.execSeaImportEntryPageDoc[0].uploadDoC != '' && _vm.execSeaImportEntryPageDoc[0].uploadDoC != null) ? _c('div', _vm._l((_vm.execSeaImportEntryPageDoc[0].uploadDoC.split(',')), function(item3, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item3 != '' && item3 != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item3,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])])]), _vm._v(" "), _c('div', [(_vm.emailData != '') ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.emailData)
    }
  })])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d6bed6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/ffDocListPage.vue
// module id = 2543
// module chunks = 0